import {
    Group, Mesh
} from 'three';
import { UNIT } from '../../../constants/sizes';
import { MaterialsFactory } from '../factories/MaterialsFactory';
import { materialsLib, objectsLib } from '../../../../data/settings';
import { getPlateGeometry } from '../geometries/PlateGeometry';
import { GeometriesFactory } from '../factories/GeometriesFactory';

export class Platform extends Group {
    #root;
    #plate;

    constructor() {
        super();

        const root = new Group();

        const material = MaterialsFactory.create(materialsLib.matcapClay);
        const geom = getPlateGeometry({
            innerR: UNIT.plateR,
            outerR: UNIT.plateR * 1.02,
            height: UNIT.plateH,
            innerHeight: UNIT.plateH * 0.5
        });

        geom.translate(0, UNIT.plateH * 0.25, 0);
        root.position.y = UNIT.plateY - UNIT.plateH * 0.25;

        const plate = new Mesh(geom, material);

        root.add(plate);
        this.add(root);

        this.#plate = plate;
        this.#root = root;
    }

    addObjects() {
        let { geometryName, material } = objectsLib.pig;
        let s = 1.6;

        let g = new Group();
        let obj3d = new Mesh(GeometriesFactory.get(geometryName), MaterialsFactory.create(material));

        g.rotation.y = -Math.PI * 0.2;
        obj3d.position.set(UNIT.refSize * 0.5, UNIT.refSize * 0.104, 0);
        obj3d.scale.set(s, s, s);

        g.add(obj3d);
        this.#root.add(g);

        geometryName = objectsLib.diagram.geometryName;
        material = objectsLib.diagram.material;

        g = new Group();
        obj3d = new Mesh(GeometriesFactory.get(geometryName), MaterialsFactory.create(material));

        g.rotation.y = Math.PI * 0.85;
        // obj3d.rotation.y = Math.PI * 0.6;
        obj3d.position.set(-UNIT.refSize * 0.15, UNIT.refSize * 0.104, UNIT.refSize * 0.49);
        obj3d.scale.set(s, s, s);

        g.add(obj3d);
        this.#root.add(g);

        geometryName = objectsLib.bank.geometryName;
        material = objectsLib.bank.material;
        s *= 0.9;

        g = new Group();
        obj3d = new Mesh(GeometriesFactory.get(geometryName), MaterialsFactory.create(material));

        g.rotation.y = Math.PI * 0.2;
        obj3d.position.set(-UNIT.refSize * 0.32, UNIT.refSize * 0.104, 0);
        obj3d.scale.set(s, s, s);

        g.add(obj3d);
        this.#root.add(g);
    }
}
